// Zasady hasla wspolne dla tworzenia konta, zmiany wlasnego hasla i resetu hasla.
export const PASSWORD_SPECIAL_CHARS = "!@#$&*()";

export const PASSWORD_MIN_LENGTH = 12;

const SPECIAL_CHARS_ERROR_KEY = "com.validation-error.pass-special-chars-info";

// Klucz tlumaczenia pierwszego naruszonego warunku albo null, gdy haslo spelnia zasady.
// Znaki sprawdzamy przed dlugoscia - spacja i % maja wlasne komunikaty.
function getPasswordRuleErrorKey(password) {
    if (typeof password !== "string") {
        return "com.validation-error.min-char-length-12";
    }

    if (/\s/.test(password)) {
        return "com.validation-error.pass-no-spaces";
    }

    if (password.includes("%")) {
        return "com.validation-error.pass-no-percent-char";
    }

    if (!/^[a-zA-Z0-9!@#$&*()]*$/.test(password)) {
        return SPECIAL_CHARS_ERROR_KEY;
    }

    if (password.length < PASSWORD_MIN_LENGTH) {
        return "com.validation-error.min-char-length-12";
    }

    return null;
}

// Przetlumaczony komunikat o naruszonej zasadzie albo null.
// t - funkcja tlumaczaca komponentu, np. (key) => this.$t(key).
export function getPasswordRuleErrorMessage(password, t) {
    const errorKey = getPasswordRuleErrorKey(password);
    if (errorKey === null) {
        return null;
    }

    if (errorKey === SPECIAL_CHARS_ERROR_KEY) {
        return `${t(errorKey)} ${PASSWORD_SPECIAL_CHARS}`;
    }

    return t(errorKey);
}

// Podpowiedz z minimalna dlugoscia i dopuszczalnymi znakami specjalnymi.
export function getPasswordRulesHint(t) {
    return `${t("com.file.add-permission.password-length-info")} ${PASSWORD_SPECIAL_CHARS}`;
}
